import routes from '../routes/index.routes';
import { Soon } from '@monorepo/base/src/components/soon/soon';
import { Advertisers } from '../../pages/advertisers/index/advertisers.page';
import { FullLayout } from '../components/layouts/full-layout/full-layout';
import { PageLayout } from '../components/layouts/page-layout/page-layout';
import { AdvertiserView } from '../../pages/advertisers/view/advertiser-view.page';
import { AdvertiserCampaigns } from '../../pages/advertisers/view/campaigns/campaigns.advertiser';
import { AdvertiserChannels } from '../../pages/advertisers/view/channels/channels.advertiser';
import { CreateAdvertiser } from '../../pages/advertisers/create/create-advertiser.page';
import { CreateCampaign } from '../../pages/campaigns/create/create-campaign.page';
import { EditAdvertiser } from '../../pages/advertisers/edit/edit-advertiser.page';
import { GuardRoute } from '../components/guard/guard-route';
import { PermissionActions } from '../enums/permissions';
import { validateAction } from '../hooks/tools/use-guard';

export const AdvertisersRouter = [
	{
		element: <FullLayout />,
		children: [
			{
				path: routes.advertisers.createCampaign(':advertiserId'),
				element: (
					<GuardRoute validate={validateAction([PermissionActions.CampaignWrite])}>
						<CreateCampaign parentRoute={routes.advertisers.index()} />
					</GuardRoute>
				),
			},
		],
	},
	{
		element: <PageLayout />,
		children: [
			{
				path: routes.advertisers.index(),
				element: <Advertisers />,
				children: [
					{
						path: routes.advertisers.create(),
						element: (
							<GuardRoute validate={validateAction([PermissionActions.AdvertiserWrite])}>
								<CreateAdvertiser />
							</GuardRoute>
						),
					},
					{
						path: routes.advertisers.edit(':advertiserId'),
						element: (
							<GuardRoute validate={validateAction([PermissionActions.AdvertiserWrite])}>
								<EditAdvertiser />
							</GuardRoute>
						),
					},
				],
			},
			{
				element: (
					<GuardRoute validate={validateAction([PermissionActions.AdvertiserRead])}>
						<AdvertiserView />
					</GuardRoute>
				),
				children: [
					{
						path: routes.advertisers.view(':advertiserId'),
						element: <Soon />,
					},
					{
						path: routes.advertisers.campaigns(':advertiserId'),
						element: <AdvertiserCampaigns />,
					},
					{
						path: routes.advertisers.channels(':advertiserId'),
						element: <AdvertiserChannels />,
					},
				],
			},
		],
	},
];
